export const DEFAULT_ATTACHMENT_TYPE = 'case_file'
export const DEFAULT_TEMPLATE_TARGET = 'case_file'

export const DEFAULT_LANGUAGE = 'de'
export const DEFAULT_TONALITY = 'no_tonality'
export const DEFAULT_COUNTRY = 'universal'
export const MANUAL_SEND_GROUP = 'manual'

export const DEFAULT_PAIR_ENVIRONMENT = 'nl'
export const OLD_SLUG_LENGTH = 12
export const SLUG_NUMBER_TO_ENVIRONMENT_MAP = {
  '101': 'de',
  '102': 'at',
  '103': 'ch',
  '104': 'nl',
  '105': 'se',
  '106': 'pl'
}

export const DEFAULT_PREVIEW_FILE_NAME = 'preview.pdf'

export const PLAIN_TEXT_TEMPLATE_KINDS = ['sms', 'rcs', 'plain']
export const TEMPLATE_WITHOUT_CONTENT_FIELD_KINDS = ['mjml', 'html']

export const ATTACHMENT_URL_VARIABLE = '{% attachment_file_url {id} %}'
export const DEBTOR_UUID_VARIABLE = '{{ primary_debtor.uuid }}'
export const DOMAIN_VARIABLE = '{{ domain }}'

export const TREE_KINDS_WITH_ITEMS_TO_SORT = [
  'variables',
  'snippets',
  'images',
  'links'
]

export const SNIPPET_TEMPLATE_KINDS = ['plain', 'mjml', 'html']
